var map = {
	"./beginningletter.png": "0d5e",
	"./buildakeyboard.png": "8261",
	"./buildasentence.png": "d8da",
	"./concentration.png": "aed0",
	"./curtaincall.png": "1a944",
	"./dolchdynamite.png": "6657",
	"./dolchspace.png": "6b11",
	"./dothemath.png": "0a59",
	"./dumpthecombo.png": "e2ef",
	"./faceflip.png": "142a",
	"./fancyformatting.png": "5197",
	"./fillblanksentences.png": "c851",
	"./fillintheblanks.png": "4f60",
	"./findtheletter.png": "88fb",
	"./graphit.png": "6459",
	"./hearittypeit.png": "dd59",
	"./homonym.png": "c03e",
	"./howto.png": "b232",
	"./isthesame.png": "0556",
	"./labelmaker.png": "0890",
	"./leftimageparagraph.png": "35c2",
	"./leftimagesentences.png": "c156",
	"./leftrightpanelreveal.png": "6b82",
	"./mathmaster.png": "142e",
	"./mathsentences.png": "4751",
	"./matmanmatch.png": "a5e5",
	"./mrsnewssyllables.png": "a22c",
	"./multipart.png": "af81",
	"./musiciansonstage.png": "62f2",
	"./mychoicekeyboarding.png": "38d8",
	"./notthesame.png": "fe15",
	"./objectinasentence.png": "26e80",
	"./objectshuffle.png": "747d",
	"./oneandmore.png": "76d1",
	"./paintedfingerclue.png": "312a",
	"./paragraphcentered.png": "3cb6",
	"./picktheanswer.png": "93df",
	"./puzzlepieces.png": "4952",
	"./puzzlingletters.png": "6d6c",
	"./qanda.png": "16b0",
	"./quotebubble.png": "e1cb",
	"./quotebubble2.png": "9590",
	"./rhymeflip.png": "feed",
	"./rhymeswith.png": "4fa8",
	"./scrolledsecrets.png": "ddf4",
	"./sentencedoctor.png": "e708",
	"./shiftforcapitals.png": "1e3c",
	"./shiftytargets.png": "d955",
	"./spacebar.png": "6eb3",
	"./startswith.png": "dbf3",
	"./stopdropandtype.png": "bb60",
	"./tabyoureit.png": "2f3d",
	"./targetpractice.png": "286c",
	"./teachercreation.png": "eb1b",
	"./topbottompanelreveal.png": "aac5",
	"./typetosee.png": "bc60",
	"./venndiagram.png": "3f50",
	"./vowelcombolaunch.png": "3a87",
	"./whackamole.png": "3334",
	"./woodpieces.png": "5a35",
	"./writemyname.png": "e60f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3da1";